import biodataWniApi from '../../../services/form/biodataWniApi'

const state = {

}

const mutations = {

}

const actions = {

	async storeFormBiodataWniPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await biodataWniApi.storeFormBiodataWniPenduduk(token, data)
	},
	async storeFormBiodataWniPenduduk({ getters }, id) {
		let token = getters.getAuthService.token
		return await biodataWniApi.storeFormBiodataWniPenduduk(token, id)
	}
}

const getters = {

}

export default {
	state,
	mutations,
	actions,
	getters
}